<template>
  <!-- App -->
  <div id="app">
    <!-- Router (History Mode) -->
    <router-view v-if="isAppAuthorized" />
    <!-- Error (Unauthorized) -->
    <div
      v-else
      class="unauthorized"
    >
      Unauthorized
    </div>
  </div>
</template>

<script>
import 'normalize.css'
import 'animate.css';

import settings from '@/mixins/settings';

export default {
  name: 'App',
  mixins: [settings],
  created () {
    // Set Axios default headers
    this.$axios.defaults.headers['session-type'] = 'web';
    // Set lang according to parent query
    this.$i18n.locale = this.$route.query.lang || process.env.VUE_APP_I18N_LOCALE;
  },
};
</script>

<!--Make sure <style> are not scoped if you @extend components-->
<style lang="scss">
// Hide recaptcha badge
.grecaptcha-badge {
  visibility: collapse;
}
</style>
